<template>

  <ContentTemplate title="Suggest change primary email" :container-size-small="true">
    <form>

      <FormGroupSection
          v-for="(item, index) in emailFormInfos"
          :key="index"
          :label="item.label"
          v-model:value="form[item.input.name]"
          :icon-type="item.iconType"
          :icon="item.icon"
          :input="item.input"/>

      <div class="row">
        <div class="col-12 d-flex justify-content-end mt-2">
          <ButtonElement
              @clickOnButton="changeEmail()"
              class="btn-purple m-0">
            Suggest Change
          </ButtonElement>
        </div>
      </div>
    </form>
  </ContentTemplate>

</template>
<script lang="ts">
import {defineComponent} from 'vue';
import {AccountNs, CommonNs,} from '@shared/types';
import useVuelidate from '@vuelidate/core';
import {email, required} from '@vuelidate/validators';
import {useUserStore} from "@shared/stores/user.store";
import {mapStores} from "pinia";
import {useAccountStore} from "@domains/account/stores/account.store";
import {ButtonElement, ContentTemplate, FormGroupSection} from "@shared/components";

export default defineComponent({
  name: 'SuggestEmailView',
  components: {
    ButtonElement,
    ContentTemplate,
    FormGroupSection,
  },
  data() {
    return {
      form: {} as { [key: string]: string },
      emailFormInfos: [] as CommonNs.InputFormGroup[],
    };
  },
  setup() {
    return {v$: useVuelidate()};
  },
  computed: {
    ...mapStores(useUserStore, useAccountStore),
    getUserName(): string {
      return this.userStore.getUserName
    },
  },
  mounted(): void {
    this.buildForm();
  },
  validations() {
    return {
      form: {
        currentEmail: {required, email},
        newEmail: {required, email},
        password: {required},
      },
    };
  },
  methods: {
    buildForm(): void {
      this.form = {
        currentEmail: this.getUserName,
        newEmail: '',
        password: '',
      };
      this.emailFormInfos = [
        {
          label: 'Current Primary Email',
          iconType: 'fal',
          icon: 'Mail',
          input: {
            name: 'currentEmail',
            type: 'text',
            placeholder: 'md@flexwork.io',
            isDisable: true,
            isLocked: true,
          },
        },
        {
          label: 'Suggest Email',
          iconType: 'fal',
          icon: 'Mail',
          input: {
            name: 'newEmail',
            type: 'text',
            placeholder: 'Empty',
          },
        },
      ] as CommonNs.InputFormGroup[];
    },
    changeEmail(): void {
      const payload = {
        newEmail: this.form.newEmail,
        password: this.form.password,
      } as AccountNs.ChangePrimaryEmailRequest;

      this.accountStore.changePrimaryEmail(payload).then(() => {
      })
    },
  },
});
</script>
